import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { KeyRound, ArrowRight } from "lucide-react";

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [channel, setChannel] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const requestOtp = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email_or_phone: emailOrPhone });
      setChannel(data.channel || "");
      toast.success("Code envoyé (vérifiez SMS / email / logs dev)");
      setStep(2);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const reset = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/reset-password", { email_or_phone: emailOrPhone, otp, new_password: newPassword });
      toast.success("Mot de passe réinitialisé !");
      navigate("/portail-admin");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 grid-bg">
      <div className="w-full max-w-md space-y-6 fade-in surface p-8 shadow-sm">
        <div className="flex items-center gap-3">
          <KeyRound size={20} className="text-[var(--primary)]"/>
          <div className="label-mono">Réinitialisation</div>
        </div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Mot de passe <span className="text-[var(--primary)]">oublié</span></h1>

        {step === 1 ? (
          <form onSubmit={requestOtp} className="space-y-4" data-testid="forgot-step1">
            <p className="text-sm text-[var(--text-muted)]">Saisissez votre email ou numéro de téléphone. Vous recevrez un code à 6 chiffres par SMS.</p>
            <div>
              <label className="label-mono block mb-2">Email ou téléphone</label>
              <input data-testid="forgot-input" required className="input-base" placeholder="vous@exemple.com ou +221..." value={emailOrPhone} onChange={(e)=>setEmailOrPhone(e.target.value)}/>
            </div>
            <button data-testid="forgot-submit" disabled={busy} className="btn-primary w-full flex items-center justify-center gap-2">{busy ? "Envoi..." : <>RECEVOIR LE CODE <ArrowRight size={14}/></>}</button>
          </form>
        ) : (
          <form onSubmit={reset} className="space-y-4" data-testid="forgot-step2">
            <p className="text-sm text-[var(--text-muted)]">Code envoyé via : <span className="text-[var(--primary)] font-data font-semibold">{channel || "—"}</span>. Saisissez le code à 6 chiffres reçu.</p>
            <div>
              <label className="label-mono block mb-2">Code OTP</label>
              <input data-testid="otp-input" required maxLength={6} className="input-base font-data text-2xl tracking-[0.5em] text-center" placeholder="000000" value={otp} onChange={(e)=>setOtp(e.target.value.replace(/\D/g,""))}/>
            </div>
            <div>
              <label className="label-mono block mb-2">Nouveau mot de passe</label>
              <input data-testid="new-pw-input" required type="password" minLength={6} className="input-base" value={newPassword} onChange={(e)=>setNewPassword(e.target.value)}/>
            </div>
            <button data-testid="reset-submit" disabled={busy} className="btn-primary w-full">{busy ? "Mise à jour..." : "RÉINITIALISER"}</button>
            <button type="button" onClick={()=>setStep(1)} className="btn-ghost w-full text-sm">← Renvoyer un code</button>
          </form>
        )}

        <div className="text-center text-xs text-[var(--text-muted)] pt-2 border-t border-[var(--border-line)]">
          <Link to="/portail-admin" className="text-[var(--primary)] font-semibold hover:underline">← Retour connexion</Link>
        </div>
      </div>
    </div>
  );
}
